//@ts-check
import * as d3 from "d3";

/**
 * @module Visibility
 */

/**
* Show or hide the single element
* @param {*} group_ID Pass the group id from the loaded drawing in 2D viewer
* @param {boolean} status If passed true value then shows the element. If passed false value then hides the element
* @returns {Object} Return success or error messages 
*/
export function showElement(group_ID, status) {
  let scope = this;
  let groupID = [];
  groupID.push(group_ID);
  scope.showElements(groupID, status);
}

/**
* Show or hide the multiple elements
* @param {Array<String>} group_IDs Pass the array of element id from the loaded drawing in 2D Viewer
* @param {boolean} status If true value then show the elements. If false value then hide the elements.
* @returns {Object} Return success or error messages 
*/
export function showElements(group_IDs, status) {
  let scope = this;
  if (scope.content._groups && scope.content._groups.length != 0) {
    let invalidIds = [];
    for (let i = 0; i < group_IDs.length; i++) {
      try {
        let result;
        if (status == true) {
          result = 'visible';
        } else {
          result = 'hidden';
        }
        let element = d3.select(scope.canvas).selectAll('#' + group_IDs[i]).selectAll(scope.types);
        element.style('visibility', result);
      } catch {
        return {
          'status': 'failed',
          'message': 'Invalid element id' + group_IDs[i]
        }
      }
    }
    return {
      'status': 'success',
      'message': 'Show Elements'
    }
  } else {
    return {
      'status': 'failed',
      'message': 'Error : Model is not colorElementloaded in viewer.'
    }
  }
}

/**
* Show or hide the loaded drawing
* @param {boolean} status If true value then show the loaded drawing. If false value then hide the loaded drawing.
* @returns {Object} Return success or error messages 
* { status:  mesage: }
*/
export function showAll(status) {
  let scope = this;
  if (scope.canvas && scope.canvas.children.length != 0) {
    if (status) {
      d3.select(scope.canvas).selectAll('g').selectAll(scope.types).style('visibility', 'visible');
    } else {
      let element = d3.select(scope.canvas).selectAll('g').selectAll(scope.types).style('visibility', 'hidden');
    }
    return {
      "status": "success",
      "message": "Show all API"
    }
  } else {
    return {
      "status": "failed",
      "message": "ERROR : Drawing is not loaded in viewer."
    }
  }
}

/**
 * Locks multiple elements
 * @param {Array<string>} group_IDs  Group Ids
 * @param {boolean} status - Status if true lock elements, if false unlock
 * @returns {Object} Return success or error messages 
 * { status:  mesage: }
 */
export function lockElements(group_IDs, status) {
  let scope = this;
  if (scope.canvas && scope.canvas.children.length != 0) {
    let invalidIds = [];
    for (let i = 0; i < group_IDs.length; i++) {
      try {
        let result;
        if (status == true) {
          result = 'locked';
        } else {
          result = 'unlocked';
        }
        d3.select(scope.canvas).selectAll('#' + group_IDs[i]).attr('status', result);

        return {
          "status": "success",
          "message": "Lock elements API"
        }
      } catch {
        return {
          "status": "failed",
          "message": "Invalid group id:" + group_IDs[i]
        }
      }
    }
    if (invalidIds.length > 0) {
    }
  } else {
    return {
      "status": "failed",
      "message": "Error : Drawing is not loaded in viewer."
    }
  }
}

/**
 * Lock or unlock the single element.
 * If locked the element then it wont get selected and highlighted
 * If unlocked the element then it will get selected and highlighted
 * @param {any} group_ID The element_ID parameter take element id of the loaded drawing
 * @param {boolean} status The status parameter lock or unlock the single element
 * @returns {Object} Return success or error messages 
 */
export function lockElement(group_ID, status) {
  let scope = this;
  let groupID = [];
  groupID.push(group_ID);
  return scope.lockElements(groupID, status);
}

/**
 * Sets the group Opacity
 * @param {*} group 
 * @param {*} opacity 
 */
export function groupOpacity(group, opacity) {
  let scope = this;

  let elements = group.selectAll(scope.types);

  if (elements._groups && elements._groups.length != 0) scope.applyOpacity(elements, opacity);
}

/**
 * Applies Opacity to the elements
 * @param {*} elements 
 * @param {*} opacity 
 */
export function applyOpacity(elements, opacity) {
  elements.attr("opacity", opacity);
}

/**
* Set the opacity of multiple elements
* @param {Array<String>} group_IDs Pass the array of element id from the loaded drawing in 2D Viewer
* @param {Number} opacity Pass opacity value to multiple elements
* @returns {Object} Return success or error messages
*/
export function setOpacity(group_IDs, opacity) {
  let scope = this;

  if (scope.content._groups && scope.content._groups.length != 0) {
    for (let i = 0; i < group_IDs.length; i++) {
      let group = scope.content.selectAll('#' + group_IDs[i]);
      scope.temp_colorBy.push(group);
      let element = group.selectAll(scope.types);
      element.style('opacity', opacity);
    }
  }
}

/**
* Set the opacity of the single element
* @param {any} group_ID Pass the element id from the loaded drawing in 2D Viewer
* @param {number} opacity Pass opacity value to single element
* @returns {Object} Return success or error messages
*/
export function setElementOpacity(group_ID, opacity) {
  let scope = this;
  let groupID = [];
  groupID.push(group_ID);
  scope.setOpacity(groupID, opacity);
}

/**
* Isolate the single element
* @param {*} group_ID Pass the element id from the loaded drawing in the 2D Viewer
*/
export function isolateElement(group_ID) {
  let scope = this;
  let groupID = [];
  groupID.push(group_ID);
  scope.isolateElements(groupID);
}

/**
 * Isolate the multiple elements
 * @param {*} group_ID Pass the array of element id from the loaded drawing in 2D Viewer
 */
export function isolateElements(group_ID) {
  let scope = this;

  if (scope.content._groups && scope.content._groups.length != 0) {
    let group = scope.content.selectAll('#' + group_ID);

    if (scope.isGhostColor) {
      scope.temp_colorBy.push(group);
      scope.colorGroup(group, scope.ghostColor);
      scope.groupOpacity(group, scope.filterOpacity);
    } else {
      group.style('visibility', 'hidden');
    }

  }
}

/**
 * Turn off background Image
 */
export function hideBackgroundImage() {
  let scope = this;
  // Find the background image by its ID and hide it
  d3.select('#background-image-' + scope.id).style('visibility', 'hidden');
  scope.backgroundImage = false;
}

/**
 * Turn on background Image
 */
export function showBackgroundImage() {
  let scope = this;
  // Find the background image by its ID and show it
  d3.select('#background-image-' + scope.id).style('visibility', 'visible');
  scope.backgroundImage = true;
}

/**
 * Toggle Background Image
 */
export function toggleBackgroundImage() {
  let scope = this;
  if (scope.backgroundImage) {
    scope.hideBackgroundImage();
  } else {
    scope.showBackgroundImage();
  }
}

/**
* Apply fade effect (reduced opacity) to elements
* @param {Array<String>} group_IDs Array of element IDs
* @param {Number} opacity Opacity value between 0.0 and 1.0
* @returns {Object} Status object
*/
export function fadeElements(group_IDs, opacity = 0.2) {
  let scope = this;

  if (scope.content._groups && scope.content._groups.length != 0) {
    for (let i = 0; i < group_IDs.length; i++) {
      let group = scope.content.selectAll('#' + group_IDs[i]);
      group.attr('data-filtered', true);
      group.attr('data-opacity', opacity);
      let element = group.selectAll(scope.types);
      element.style('opacity', opacity);
    }
    return {
      'status': 'success',
      'message': 'Fade elements applied'
    };
  }
  return {
    'status': 'failed',
    'message': 'Error: Drawing is not loaded in viewer'
  };
}

/**
* Apply ghost effect (grey color) to elements
* @param {Array<String>} group_IDs Array of element IDs
* @returns {Object} Status object
*/
export function ghostElements(group_IDs, opacity = 0.2) {
  let scope = this;
  
  // Define ghost color with fallback
  const ghostColor = scope.ghostColor || '#888888';
  
  if (scope.content._groups && scope.content._groups.length != 0) {
    for (let i = 0; i < group_IDs.length; i++) {
      try {
        // Make sure we're selecting from content selection, which has the actual SVG elements
        let group = scope.content.selectAll('#' + group_IDs[i]);
        
        if (group._groups && group._groups.length > 0 && group._groups[0].length > 0) {
          // Mark element as ghosted and store its original color state
          group.attr('data-ghosted', 'true');
          group.attr('data-opacity', opacity);

          // Store color information before ghosting
          if (group.attr('data-isCol') === 'true') {
            group.attr('data-prev-color', group.attr('data-color'));
          }
          
          // Important: Apply ghost color directly to bypass any color update issues
          group.attr('data-color', ghostColor);
          group.attr('data-isCol', 'true'); // Mark as colored
          
          // Force direct style application to all elements in the group
          group.selectAll(scope.types).each(function() {
            if (this.getAttribute("data-isFill") === 'true' && this.style.fill !== 'none') {
              this.dataset.originalFill = this.style.fill;
              this.style.fill = ghostColor;
            }
            if (this.getAttribute("data-isStroke") === 'true' && this.style.stroke !== 'none') {
              this.dataset.originalStroke = this.style.stroke;
              this.style.stroke = ghostColor;
            }
          });
          
          // Apply opacity
          group.selectAll(scope.types).style('opacity', opacity);

          // Add to temp_colorBy for tracking
          scope.temp_colorBy.push(group);
        }
      } catch (error) {
        console.error('Error applying ghost effect to element:', group_IDs[i], error);
      }
    }
    
    return {
      'status': 'success',
      'message': 'Ghost elements applied successfully'
    };
  }
  
  return {
    'status': 'failed',
    'message': 'Error: Drawing is not loaded in viewer'
  };
}

/**
* Restore original appearance of filtered elements
* @param {Array<String>} group_IDs Array of element IDs
* @returns {Object} Status object
*/
export function restoreElements(group_IDs) {
  let scope = this;

  if (scope.content._groups && scope.content._groups.length != 0) {
    for (let i = 0; i < group_IDs.length; i++) {
      let group = scope.content.selectAll('#' + group_IDs[i]);
      
      // Remove filter flags
      group.attr('data-filtered', null);
      group.attr('data-opacity', null);
      group.attr('data-ghosted', null);
      
      // Reset styles
      let element = group.selectAll(scope.types);
      element.style('opacity', 1);
      scope.clearGroupStyle(group);
    }
    return {
      'status': 'success',
      'message': 'Elements restored'
    };
  }
  return {
    'status': 'failed',
    'message': 'Error: Drawing is not loaded in viewer'
  };
}

/**
* Clear all filter effects across the drawing
* @returns {Object} Status object
*/
export function removeFilterEffects() {
  let scope = this;
  
  if (scope.content._groups && scope.content._groups.length != 0) {
    try {
      // Find all elements with filter flags
      scope.content.selectAll('[data-ghosted], [data-filtered]').each(function() {
        let group = d3.select(this);
        
        // Remove filter flags
        group.attr('data-filtered', null);
        group.attr('data-opacity', null);
        group.attr('data-ghosted', null);
        
        // If element was colored before filtering, restore the original color
        if (group.attr('data-prev-color')) {
          const prevColor = group.attr('data-prev-color');
          group.attr('data-color', prevColor);
          group.attr('data-prev-color', null);
          
          if (prevColor && group.attr('data-isCol') === 'true') {
            // Re-apply the previous color
            scope.colorGroup(group, prevColor);
          } else {
            // Otherwise just clear styles
            scope.clearGroupStyle(group);
            group.attr('data-isCol', 'false');
          }
        } else {
          // No previous color recorded, just clear style
          scope.clearGroupStyle(group);
          group.attr('data-isCol', 'false');
        }
        
        // Reset opacity
        group.selectAll(scope.types).style('opacity', 1);
      });
      
      // Make all elements visible again
      scope.showAll(true);
      
      return {
        'status': 'success',
        'message': 'All filter effects removed'
      };
    } catch (error) {
      console.error('Error removing filter effects:', error);
      return {
        'status': 'failed',
        'message': 'Error removing filter effects: ' + error.message
      };
    }
  }
  
  return {
    'status': 'failed',
    'message': 'Error: Drawing is not loaded in viewer'
  };
}
